export const authUser = "auth-user";
export const guestUser = "guest-user";
export const ScanData = "scan-data";
export const authUserCredentials = "auth-user-credentials";
